import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { environment } from '@env/environment';
import { OAuthModuleConfig, OAuthResourceServerErrorHandler } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@app/core/auth/auth.service';
import _ from 'lodash';
import { Logger } from '@app/core/logging/logger';
import { HttpStatusCode } from '@app/core/enums/http-status-code.enum';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private errorHandler = inject(OAuthResourceServerErrorHandler);
    private injector = inject(Injector);
    private moduleConfig = inject(OAuthModuleConfig, { optional: true })!;
    private log = inject(Logger);


    private checkUrl(url: string): boolean {
        return this.moduleConfig.resourceServer.allowedUrls.some(u => url.startsWith(u));
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!environment.authEnabled
            || !_.get(this, 'moduleConfig.resourceServer.allowedUrls')
            || !this.checkUrl(req.url.toLowerCase())) {
            return next.handle(req);
        }

        const authService = this.injector.get(AuthService);
        if (this.moduleConfig.resourceServer.sendAccessToken) {
            const header = 'Bearer ' + authService.getAccessToken;
            const headers = req.headers.set('Authorization', header);

            req = req.clone({headers});
        }

        return next.handle(req).pipe(
            catchError(err => {
                if ([HttpStatusCode.Unauthorized].indexOf(err.status) !== -1) {
                    this.log.error(new Error('Unauthorized request'), {error: err});
                    authService.logout();
                }
                return this.errorHandler.handleError(err);
            })
        );
    }
}
